import { planTypes } from '@/common/constants';

const planType = planTypes.ZOOM_ROOMS;

export default {
  key: planTypes[planType],
  data() {
    return {
      planType,
      title: this.$t('billing.planform.title.zoomroom'),
      logo: require('@/assets/plans/zoom_room.svg'),
      description: this.$t('billing.zr.desc'),
    };
  },
};
